import type { SampleTestDto } from '@/api';

/*
 * Формы плана тестирования образцов: перенос (дата теста и комментарий) и
 * закрытие итогом (комментарий). Черновик - строки полей, тело запроса - здесь.
 */

export interface ScheduleDraft {
  /** Дата теста, ISO-день из <input type="date">; '' - не выбрана. */
  testDate: string;
  comment: string;
}

/** Черновик переноса - текущие дата и комментарий теста. */
export const createScheduleDraft = (test: SampleTestDto): ScheduleDraft => ({
  testDate: test.testDate,
  comment: test.comment ?? '',
});

/** Перенести можно, когда дата выбрана; остальное проверяет сервер. */
export const canSubmitSchedule = (draft: ScheduleDraft): boolean =>
  draft.testDate !== '';

/** Тело переноса: пустой комментарий снимает прежний. */
export const toScheduleBody = (
  draft: ScheduleDraft,
): { testDate: string; comment: string | null } => ({
  testDate: draft.testDate,
  comment: draft.comment.trim() === '' ? null : draft.comment.trim(),
});

/** Закрыть можно с комментарием к итогу: он обязателен, как на сервере. */
export const canSubmitClose = (comment: string): boolean =>
  comment.trim() !== '';

/** Тело закрытия: комментарий к итогу заменяет прежний. */
export const toCloseBody = (comment: string): { comment: string } => ({
  comment: comment.trim(),
});
